__turbopack_context__.v({
  "hint": "SearchTrigger-module__iPIH4G__hint",
  "icon": "SearchTrigger-module__iPIH4G__icon",
  "phrase": "SearchTrigger-module__iPIH4G__phrase",
  "trigger": "SearchTrigger-module__iPIH4G__trigger",
});
